import React, { useState } from 'react';
import { CircleCheckBig, ListTodo, UsersRound, Wrench } from 'lucide-react';

// TOP_REVIEWER_ENABLED: set to true to re-enable the Top reviewer toggle and table
const TOP_REVIEWER_ENABLED = false;

function CampaignPerformance({ topChampions = [], reviewStatus = {}, reviewsPerQE = [], noHeader, onGoToReviewStatus }) {
  const [activeTable, setActiveTable] = useState('champions');

  const grandTotalBugs = topChampions.reduce((s, r) => s + r.total, 0);
  const grandTotalMinor = topChampions.reduce((s, r) => s + r.minor, 0);
  const grandTotalMajor = topChampions.reduce((s, r) => s + r.major, 0);
  const grandTotalCrit = topChampions.reduce((s, r) => s + r.critical, 0);
  const grandTotalScore = topChampions.reduce((s, r) => s + r.score, 0);
  const grandTotalQE = reviewsPerQE.reduce((s, r) => s + r.tickets, 0);

  return (
    <>
      {!noHeader && <div className="section-header">Campaign Performance</div>}
      <div className="section-body" style={noHeader ? { border: 'none', padding: 0 } : {}}>

        {/* Review status */}
        <div className="performance-bottom">
          <div>
            <div className="section-header" style={{ borderRadius: 6, marginBottom: 16 }}>Review Status</div>
            <div className="review-status-cards">
              <div className={`review-card${onGoToReviewStatus ? ' review-card-link' : ''}`} onClick={() => onGoToReviewStatus?.('__none__')}>
                <div className="rc-icon"><ListTodo size={18} /></div>
                <div className="rc-label">Review backlog</div>
                <div className="rc-value">{reviewStatus.backlog}</div>
              </div>
              <div className={`review-card${onGoToReviewStatus ? ' review-card-link' : ''}`} onClick={() => onGoToReviewStatus?.('In Progress')}>
                <div className="rc-icon"><Wrench size={18} /></div>
                <div className="rc-label">In Progress</div>
                <div className="rc-value">{reviewStatus.inProgress}</div>
              </div>
              <div className={`review-card${onGoToReviewStatus ? ' review-card-link' : ''}`} onClick={() => onGoToReviewStatus?.('Passed to PU')}>
                <div className="rc-icon"><UsersRound size={18} /></div>
                <div className="rc-label">Passed to PU</div>
                <div className="rc-value">{reviewStatus.passedToPU}</div>
              </div>
              <div className={`review-card completed${onGoToReviewStatus ? ' review-card-link' : ''}`} onClick={() => onGoToReviewStatus?.('Review Completed')}>
                <div className="rc-icon"><CircleCheckBig size={18} /></div>
                <div className="rc-label">Completed</div>
                <div className="rc-value">{reviewStatus.completed}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Top contributor table */}
        <div className="section-header" style={{ borderRadius: 6, marginBottom: 12 }}>Top contributor</div>

        {TOP_REVIEWER_ENABLED && (
          <div style={{ display: 'flex', gap: 4, marginBottom: 16 }}>
            {[
              { key: 'champions', label: 'Top reporter' },
              { key: 'reviews', label: 'Top reviewer' },
            ].map(v => (
              <button
                key={v.key}
                onClick={() => setActiveTable(v.key)}
                style={{
                  flex: 1,
                  padding: '6px 12px',
                  fontSize: 12,
                  borderRadius: 4,
                  border: '1px solid var(--cmp-border)',
                  cursor: 'pointer',
                  background: activeTable === v.key ? 'var(--cmp-primary)' : 'var(--cmp-card-bg)',
                  color: activeTable === v.key ? '#fff' : 'var(--cmp-text)',
                  fontWeight: activeTable === v.key ? 600 : 400,
                }}
              >
                {v.label}
              </button>
            ))}
          </div>
        )}

        {(!TOP_REVIEWER_ENABLED || activeTable === 'champions') && (
          <div className="perf-table-scroll">
            <table className="champions-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Reporter</th>
                  <th>Total Bugs</th>
                  <th className="minor-col">🙁 Minor</th>
                  <th className="major-col">🔥 Major</th>
                  <th className="critical-col">🚨 Critical</th>
                  <th className="score-col">Score ↓</th>
                </tr>
              </thead>
              <tbody>
                {topChampions.map(row => (
                  <tr key={row.rank}>
                    <td>{row.rank}.</td>
                    <td>{row.name}</td>
                    <td>{row.total}</td>
                    <td>{row.minor}</td>
                    <td>{row.major}</td>
                    <td>{row.critical}</td>
                    <td><span className="score-cell">{row.score}</span></td>
                  </tr>
                ))}
                <tr className="grand-total">
                  <td></td>
                  <td>Grand total</td>
                  <td>{grandTotalBugs}</td>
                  <td>{grandTotalMinor}</td>
                  <td>{grandTotalMajor}</td>
                  <td>{grandTotalCrit}</td>
                  <td><span className="score-cell">{grandTotalScore}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {TOP_REVIEWER_ENABLED && activeTable === 'reviews' && (
          <div className="perf-table-scroll">
            <table className="reviews-per-qe-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Reviewer</th>
                  <th>Ticket reviewed</th>
                </tr>
              </thead>
              <tbody>
                {reviewsPerQE
                  .sort((a, b) => b.tickets - a.tickets)
                  .map((row, i) => (
                    <tr key={row.assignee}>
                      <td>{i + 1}.</td>
                      <td>{row.assignee}</td>
                      <td><span className="ticket-count">{row.tickets}</span></td>
                    </tr>
                  ))}
                <tr className="grand-total">
                  <td></td>
                  <td>Grand total</td>
                  <td><span className="ticket-count">{grandTotalQE}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

      </div>
    </>
  );
}

export default CampaignPerformance;
